import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IInformation } from '../../../../interfaces/Information.interfaces';
import { InfoHorizontalListSummaryView } from './InfoHorizontalListSummaryView';

interface InfoHorizontalListSummaryViewGroupProps {
  informations: IInformation[];
}

export const InfoHorizontalListSummaryViewGroup = ({ informations }: InfoHorizontalListSummaryViewGroupProps) => {
  return (
    <Container id={'info-popular-swiper-container'}>
      <CustomSwiper
        // 페이지 가로 너비에 따라서 한 Page에서 보여줄 Slide 수 계산
        slidesPerView={
          document.documentElement.clientWidth > 512 ? 512 / 332 : document.documentElement.clientWidth / 332
        }
        // 슬라이드 사이의 간격
        spaceBetween={16}
      >
        {informations.map((information) => (
          <CustomSwiperSlide>
            <InfoHorizontalListSummaryView key={information.id} information={information} />
          </CustomSwiperSlide>
        ))}
      </CustomSwiper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);
  min-height: 93px;

  padding: 0px 16px;

  transform: translateX(-16px);

  gap: 16px;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  height: 93px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;

  cursor: pointer;
`;
